import Component, { ComponentLoader } from '@bythepixel/component-loader';
import InViewSrcset from '@bythepixel/in-view-srcset';
import PublishOn from '../../components/publishOn';
import ContentModal from '../contentModal';

export default class xhrModalLink extends Component {
  static selector = '[comp-xhr-modal-link]'

  #modalElement
  #modalComponents

  constructor(...args) {
    super(...args);
    this.events();
  }

  initSubComponents() {
    this.#modalComponents = new ComponentLoader(this.#modalElement, [InViewSrcset, ContentModal, PublishOn], () => {
      this.#modalComponents.publish('content-modal:toggle');
    });
  }

  events() {
    this.$container.addEventListener('click', (e) => {
      e.preventDefault();
      this.onClick();
    });
  }

  onClick() {
    if (!this.#modalElement) {
      this.appendModalToDOM();
    } else {
      this.#modalComponents.publish('content-modal:toggle');
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async fetchContent(url) {
    const urlWithParms = new URL(url);
    urlWithParms.search = new URLSearchParams({ modal: true });
    // eslint-disable-next-line compat/compat
    const headers = new Headers({ 'X-Requested-With': 'XMLHttpRequest' });

    const resp = await fetch(urlWithParms, { headers });
    return resp.text();
  }

  async appendModalToDOM() {
    const markup = await this.fetchContent(this.$container.href);
    this.#modalElement = document.createElement('div');
    this.#modalElement.innerHTML = markup;
    this.$container.parentNode.appendChild(this.#modalElement);
    this.initSubComponents();
  }
}
